import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "src/services/auth/auth.service";
import { Role } from "src/services/user/role.enum";

export const IsAdminOrDriverGuard = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const currentUser = await authService.getActiveUser();

  if (currentUser?.role === Role.admin || currentUser?.role === Role.driver) {
    return true;
  } else {
    const target = "/";

    await router.navigate([target]);
    return false;
  }
};
